import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.trim.js";
import i18n from 'i18next';
import { ALLOWED_EMAIL_TAGS, BASE_TAGS, CONTENT_TAGS, RECIPIENT_TAGS, SENDER_TAGS } from './constants';
function getFormattedTagsList(tags) {
  return new Intl.ListFormat(i18n.language, {
    style: 'short',
    type: 'disjunction'
  }).format(tags);
}
var edgeCaseTags = ['{{/if}}', '{{#if content.dueDate}}', '{{#if author.displayName}}'];
var allAllowedEmailTags = [].concat(_toConsumableArray(ALLOWED_EMAIL_TAGS), edgeCaseTags);
export default function validateEmailTags(body) {
  var matchedRecipientTags = body.match(/(%)(.*?)\1/g);
  var matchedMixedTags = body.match(/({?){{(.*?)}}(}?)/g);
  var allMatchedTags = [matchedRecipientTags, matchedMixedTags].flat().filter(Boolean);
  if (allMatchedTags.length === 0) {
    return;
  }
  allMatchedTags.forEach(function (tag) {
    if (tag === null) return; // Required for TS to not complain about null, even though it's filtered out above

    if (!allAllowedEmailTags.includes(tag)) {
      var tagsList = '';
      if (tag.includes('recipient')) {
        tagsList = getFormattedTagsList(RECIPIENT_TAGS);
      } else if (tag.includes('author')) {
        tagsList = getFormattedTagsList(SENDER_TAGS);
      } else if (tag.includes('domain')) {
        tagsList = getFormattedTagsList(BASE_TAGS);
      } else if (tag.includes('content')) {
        tagsList = getFormattedTagsList(CONTENT_TAGS);
      }
      throw Error(tagsList === '' ? i18n.t('alert_invalid_placeholder_tag', {
        tag: tag,
        // Use different interpolation prefix/suffix to avoid interpolation of the tags so they can be displayed to the user
        interpolation: {
          prefix: '<<',
          suffix: '>>'
        }
      }) : i18n.t('alert_invalid_placeholder_tag_suggestion', {
        tag: tag,
        list: tagsList,
        interpolation: {
          prefix: '<<',
          suffix: '>>'
        }
      }));
    }
  });
}
export function validateEmailFields(value, emptyAlertKey) {
  if ((value === null || value === void 0 ? void 0 : value.trim()) === '') {
    return i18n.t(emptyAlertKey || 'error_required_field');
  } else if (typeof value === 'string') {
    try {
      validateEmailTags(value);
    } catch (err) {
      return err.message;
    }
  }
  return undefined;
}